import { AxiosResponse } from 'axios';
import api from 'api/base';
import { VerifyEmailPayload } from 'features/admin-email-verification/api/types';

export const verifyEmailAPI = async (
  payload: VerifyEmailPayload
): Promise<AxiosResponse<void>> => {
  return api.post<void>('admin/email-verification/verify', payload);
};

export const sendEmailVerificationTokenAPI =
  async (): Promise<AxiosResponse> => {
    return api.post('admin/email-verification/send-token');
  };
